const assertUnreachable = (x: never, errorMsg?: string): never => {
  throw new Error(errorMsg ?? "Didn't expect to get here");
};

export default assertUnreachable;
